import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Modal, Table } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";

//components
import withPermissions from "~/hoc/withPermissions";
import applicationRouter from "~/hoc/applicationRouter";
import withLocalization from "~/hoc/withLocalization";
import Checkbox from "../../../components/CustomCheckbox/CustomCheckbox";
import { SimpleSelectWidget } from "../../../components/GenericForm/Widgets/SimpleSelect";
import GenericSearch from "../../../components/GenericForm/IntegrationFilter";

//elements
import Button from "../../../components/CustomButton/CustomButton.jsx";

//assets
import CloseIcon from "~/assets/img/modal-close-icon.svg";
import ActivateUser from "../../../assets/img/ActivateUser.svg"
import LoadingSpinner from "../../../elements/LoadingSpinner";

//constants
import { payrollIntegrationOptions } from "../../../utils/constants.js";

const page_size = 10;

class ProjectTaskImport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showImportModal: true,
            loading: false,
            selectedProject: null,
            tasks : [],
            taskAddIds : [],
            pageInfo : null,
            nextCursorToken : null,
            previousCursorToken : null,
            showResponseText : '',
            lastFetchParams : null,
            currentFilters : null
        }
    }

    componentDidMount() {
        const { fromProjectList, selectedProjectIntId } = this.props;
        if (fromProjectList && selectedProjectIntId) {
            this.setState({ selectedProject: selectedProjectIntId });
            this.loadData({ projectId: selectedProjectIntId });
        }
    }

    getCurrentProjectId = () => {
        const { fromProjectList, selectedProjectIntId } = this.props;
        return fromProjectList ? selectedProjectIntId : this.state.selectedProject;
    }

    buildParams = (options = {}) => {
        const { fromProjectList, selectedProjectIntId } = this.props;
        let projectId, projectIntId;
        if(fromProjectList) {
            projectId = this.props.selectedProjectId;
            projectIntId = selectedProjectIntId;
        } else {
            const projectData = this.props.projectMapping.find(p => p.integrationDbId === this.state.selectedProject);
            projectId = projectData.projectId;
            projectIntId = projectData.integrationDbId;
        }
        const { 
            isNext = null,
            pageSize = page_size,
            filter = {},
        } = options;

        const params = {
            filter: {
                projectDbId: parseInt(projectIntId),
                ...filter
            },
            projectId
        };

        if (isNext === true) {
            params.first = pageSize;
            params.after = this.state.nextCursorToken;
        } else if (isNext === false) {
            params.last = pageSize;
            params.before = this.state.previousCursorToken;
        } else {
            params.first = pageSize;
        }

        return params;
    }

    selectAllNonSyncedTasks = (tasksList) => {
        const nonSyncedTasks = tasksList.filter(task => !task.isSynced);
        this.setState({ taskAddIds: nonSyncedTasks });
    }

    loadData = async (options = {}) => {
        const { projectStore, commonStore } = this.props;
        
        this.setState({ loading: true });
        try {
            const params = this.buildParams(options);
            const { list, pageInfo, nextCursorToken, previousCursorToken } = 
                await projectStore.getProjectsTaskFromIntegration(params);
            
            this.setState({ 
                tasks: list, 
                pageInfo, 
                nextCursorToken, 
                previousCursorToken, 
                loading: false,
                lastFetchParams : params
            }, () => {
                this.selectAllNonSyncedTasks(list);
            });
        } catch (error) {
            commonStore.addNotification(error.message || 'Failed to load tasks', null, 'error');
            this.setState({ loading: false });
        }
    }

    handleProjectChange = async (projectId) => {
        const { fromProjectList, projectMapping } = this.props;
        if (!fromProjectList) {
            const projectData = projectMapping.find(p => p.integrationDbId === projectId);
            if (!projectData) return;
        }
        this.setState({ selectedProject: projectId }, async () => { await this.loadData({ projectId })});
    }

    handleFilterChange = (filters) => {
        this.setState({ currentFilters: filters }, () => {
            this.loadData({ filter: filters });
        });
    }

    handlePageChange = (isNext) => {
        const { commonStore, t } = this.props;
        const { nextCursorToken, previousCursorToken, currentFilters } = this.state;
        if ((!nextCursorToken && isNext) || (!previousCursorToken && !isNext)) {
            return commonStore.addNotification(t("No data to display"), null, 'warning');
        }
        this.loadData({ isNext, filter : currentFilters});
    }

    handleCheckbox = (ele, e) => {
        if(e) {
            this.setState({taskAddIds : [ele, ...this.state.taskAddIds]})
        }
        else {
            const updateIds = this.state.taskAddIds.filter(item => item.task.node.activityDbId !== ele.task.node.activityDbId);
            this.setState({taskAddIds : updateIds})
        }
    }

    isTaskSelected = (task) => {
        return this.state.taskAddIds.some(item => item.task.node.activityDbId === task.task.node.activityDbId);
    }

    importTaskFromIntegration = async () => {
        const { commonStore, t , taskStore, fromProjectList} = this.props;
        const { taskAddIds, lastFetchParams } = this.state;
        let projectId, projectIntId;
        if(fromProjectList) {
            projectId = this.props.selectedProjectId;
            projectIntId = this.props.selectedProjectIntId;
        } else {
            const projectData = this.props.projectMapping.find(p => p.integrationDbId === this.state.selectedProject);
            projectId = projectData.projectId;
            projectIntId = projectData.integrationDbId;
        }
        const str = t(`Are you sure you want to import the selected task into TimeAndControl?`);
        confirmAlert({
            title : t('Confirm to Import'),
            message : str,
            buttons : [
                {
                    label: t('Yes'),
                    onClick: async () => {
                        try {
                        this.setState({loading : true})
                        const res2 = await taskStore.saveTaskFromIntegration({ tasks: taskAddIds, projectId, projectIntId, ...lastFetchParams });
                        commonStore.addNotification(`${t(res2.message)} ${commonStore.config?.integration_details?.product}`, null, 'success');
                        await this.loadData(lastFetchParams);
                        this.setState({loading : false, taskAddIds : []});
                        return res2;
                    } catch (error) {
                        console.error({error});
                        commonStore.addNotification(`${t(error.message || 'Something went wrong')}`, null, 'error');
                        this.setState({ loading: false });
                        throw error;
                        }
                    }
                }
            ]
        })
    }

    render() {
        const { showImportModal, loading , pageInfo, showResponseText, tasks, lastFetchParams } = this.state;
        const { handleTaskImportModal, projects, t, fromProjectList } = this.props;
        let projectOptions = [];
        if(!fromProjectList) {
            projectOptions = projects.map((item)=> ({
                value : item.project.node.dbId,
                label: item.project.node.description
            }))
        }
        return (
            <Modal
                size="lg"
                className="modal fade"
                show={showImportModal}
                onHide={() => handleTaskImportModal(!this.state.showImportModal)}
            >
                <Modal.Header>
                    <Modal.Title>
                        {t('Import Tasks from ') + this.props.commonStore.config?.integration_details?.product}
                    </Modal.Title>
                    <div
                        className="modal-header__revised__closebtn"
                        onClick={() => handleTaskImportModal(!this.state.showImportModal)}
                    >
                        <img src={CloseIcon} className="cursor-pointer" alt="close_button" />
                    </div>
                </Modal.Header>
                <Modal.Body className="mb-2" style={{ minHeight: '300px' }}>
                    <GenericSearch entity="tasks" onChange={this.handleFilterChange} fromDateTooltip='Filter tasks that started after from date'
                            toDateTooltip='Filter tasks that started before to date' displayName='Tasks'/>

                    {!fromProjectList && (
                        <SimpleSelectWidget
                            options={projectOptions}
                            onChange={this.handleProjectChange}
                            value={this.state.selectedProject}
                            placeholder="Select Project"
                            isSearchable
                            isClearable
                        />
                    )}
                    {loading ? (
                        <LoadingSpinner />
                    ) : (
                        <Fragment>
                            {showResponseText === '' ? (
                                <>
                                    {tasks && tasks.length ? (
                                        <div>
                                            <div className="d-flex justify-content-space-between align-items-center mb-2 w-100">
                                                <div>
                                                    <span className="fw-bold font-size-15">
                                                        {t('Select a task to import')}
                                                    </span>
                                                </div>
                                                {this.props.commonStore.config?.integration_details?.product ===
                                                    payrollIntegrationOptions.XLEDGER && (
                                                    <div>
                                                        <Button
                                                            disabled={!pageInfo?.hasPreviousPage}
                                                            onClick={() => this.handlePageChange(false)}
                                                        >
                                                            <i class="fa fa-arrow-left me-1" aria-hidden="true"></i>
                                                            {t('Prev')}
                                                        </Button>
                                                        <Button
                                                            fill
                                                            wd
                                                            disabled={!pageInfo?.hasNextPage}
                                                            style={{ margin: '0 1em' }}
                                                            onClick={() => this.handlePageChange(true)}
                                                        >
                                                            {t('Next')}
                                                            <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="projectMemberForm">
                                                <Table className="w-100 " style={{ minHeight: '10vh' }}>
                                                    <thead>
                                                        <tr className="w-100">
                                                            <th width={'50%'} style={{ textAlign: 'left' }}>
                                                                {t('Tasks')}
                                                            </th>
                                                            <th width={'50%'}>{t('Synced')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tasks.length &&
                                                            tasks.map((ele, idx) => (
                                                                <tr key={idx} className="text-capitalize mt-1">
                                                                    <td
                                                                        width={'50%'}
                                                                        className=""
                                                                        style={{ textAlign: 'left' }}
                                                                    >
                                                                        <div className="d-flex align-items-center gap-2">
                                                                        <span>{ele?.task?.node?.activity?.description}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td width={'50%'} className="timelog_array_details">
                                                                        {ele.isSynced ? (
                                                                            <img
                                                                                src={ActivateUser}
                                                                                alt="tick"
                                                                                title="Already Synced"
                                                                            />
                                                                        ) : (
                                                                            <Checkbox
                                                                                isChecked={this.isTaskSelected(ele)}
                                                                                onChange={(checked) =>
                                                                                    this.handleCheckbox(ele, checked)
                                                                                }
                                                                                disabled={ele.isSynced}
                                                                                wrapperClassName={
                                                                                    'bulk-shift-chekbox-style'
                                                                                }
                                                                            />
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <div className="text-muted">{t('No tasks found')}</div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div className="d-flex justify-content-center align-items-center flex-column">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="60px"
                                            height="60px"
                                            viewBox="0 0 1024 1024"
                                        >
                                            <path
                                                fill="#2550AC"
                                                d="M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"
                                            ></path>
                                        </svg>
                                        <div className="w-75">{showResponseText}</div>
                                    </div>
                                </>
                            )}
                        </Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {showResponseText === '' ? (
                        <>
                            <Button
                                fill
                                wd
                                onClick={this.importTaskFromIntegration}
                                disabled={!this.state.taskAddIds.length}
                            >
                                {t('Import Selected Tasks')}
                            </Button>
                            <Button wd onClick={() => handleTaskImportModal(!this.state.showImportModal)}>
                                {t('Cancel')}
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button wd onClick={() => handleTaskImportModal(!this.state.showImportModal)}>
                                {t('OK')}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        );
    }
}
export default inject(
    'projectStore',
    'userStore',
    'commonStore',
    'clientStore',
    'taskStore'
)(applicationRouter(withPermissions(withLocalization(observer(ProjectTaskImport)))));